define.alias("shared/components/shared/credentials/upgrade-button", "settings/components/shared/credentials/upgrade-button");